import HandleTabel from './containers/handle_tabel/TablePage';
import './index.less';
import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'dva';

const RuleEngine = (props) => {
  const { id, hostType } = props.location.query;

  const dispatch = useDispatch();
  // 发起请求
  const fetchData = useCallback(() => {
    dispatch({
      type: 'conditionDetail/getHandleList',
      payload: {
        values: {
          hostId: id,
          hostType: hostType || 'RULE_OUTPUT_RESULT',
        },
      },
    });
  }, [dispatch, id]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  return (
    <div className="re">
      <div className="contain">
        <HandleTabel />
      </div>
    </div>
  );
};

export default RuleEngine;
